
import DnModal from '@digitalnatives/modal';

export default {
    extends: DnModal
};
